import { ICategory } from "web/types/Category";

const getUniqueTreeCategories = (treeCategories: ICategory[]): ICategory[] => {
  return [...new Map(treeCategories?.map((item) => [item.id, item])).values()];
};

export default getUniqueTreeCategories;
